import { useState } from "react";
import { KAARTEN, type KaartMeta } from "../../lib/docs";
import { Icon } from "../Icon";

// Kaarten — web-geoptimaliseerde weergaven van de NEXXT-tekeningen.
// Grid met thumbnails; tik opent een fullscreen pan/zoom-weergave.
// De webp's zitten in de PWA-precache en werken dus offline op het terrein.

function KaartView({ kaart, onBack }: { kaart: KaartMeta; onBack: () => void }) {
  return (
    <div className="fixed inset-0 z-40 bg-ink-950 flex flex-col">
      <div className="flex items-center gap-2 px-3 py-2 border-b border-line shrink-0">
        <button
          onClick={onBack}
          className="flex items-center gap-1.5 text-sm text-zinc-300 hover:text-zinc-100 py-1.5 pr-2 min-h-[44px]"
        >
          <Icon.Close className="w-4 h-4" />
          Terug
        </button>
        <span className="text-sm text-zinc-400 truncate flex-1">
          {kaart.title}
        </span>
        {kaart.pdf && (
          <a
            href={kaart.pdf}
            target="_blank"
            rel="noopener"
            className="text-xs text-accent border border-accent/40 rounded-lg px-2.5 py-1.5 shrink-0"
          >
            PDF (inzoombaar)
          </a>
        )}
      </div>
      {/* Pan-container: img op natuurlijke grootte, scrollen = pannen; pinch-zoom
          werkt via de browser. Geen custom zoom-code — dit moet onder stress werken. */}
      <div className="flex-1 overflow-auto">
        <img
          src={kaart.file}
          alt={`${kaart.title} — ${kaart.subtitle}`}
          className="max-w-none"
          loading="eager"
        />
      </div>
    </div>
  );
}

export function KaartenGrid() {
  const [open, setOpen] = useState<KaartMeta | null>(null);

  if (open) {
    return <KaartView kaart={open} onBack={() => setOpen(null)} />;
  }

  return (
    <div className="grid grid-cols-2 gap-3">
      {KAARTEN.map((k) => (
        <button
          key={k.id}
          onClick={() => setOpen(k)}
          className="card overflow-hidden text-left hover:border-accent/40 transition-colors"
        >
          <div className="aspect-[4/3] bg-ink-900 overflow-hidden">
            <img
              src={k.file}
              alt=""
              loading="lazy"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="p-2.5">
            <div className="text-sm text-zinc-200 leading-snug">{k.title}</div>
            <div className="text-2xs text-zinc-500 mt-0.5 leading-snug">
              {k.subtitle}
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}
